import { ToolInterface } from "./toolInterface";

export const louvreCutoutsEditorKeyboardGuardToolName = "dextall-editor-louvre-cutouts-keyboard-guard-tool";

/**
 * While the louvre cutouts editor is open, the viewer's default Escape handling clears the model
 * selection, which in turn hides the editor panel. This tool consumes the Escape key inside the
 * viewer's tool pipeline so the selection (and therefore the panel) is preserved. It is only
 * activated while the louvre cutouts editor is visible.
 */
export class LouvreCutoutsEditorKeyboardGuardTool extends ToolInterface {
    constructor() {
        super();

        this.names = [louvreCutoutsEditorKeyboardGuardToolName];
    }

    getPriority() {
        return 42; // Use any number higher than 0 (the priority of all default tools)
    }

    handleKeyDown(event: KeyboardEvent) {
        return event.code === "Escape";
    }
}
